import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeCase: null,
  caseHistory: [],
};

export const backendSlice = createSlice({
  name: 'case',
  initialState,
  reducers: {
    setActiveCase: (state, action) => {
      state.activeCase = action.payload;
      if (!state.caseHistory.includes(action.payload)) {
        state.caseHistory.push(action.payload);
      }
    },
    clearActiveCase: (state) => {
      state.activeCase = null;
    }
  }
});

export const { setActiveCase, clearActiveCase } = backendSlice.actions;
export default backendSlice.reducer;